var _defs, _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLearning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.286,
    height: 25.286,
    viewBox: "0 0 25.286 25.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6a709f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.198)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M170.445,0a4.47,4.47,0,1,0,4.445,4.494A4.492,4.492,0,0,0,170.445,0Z",
    transform: "translate(-166)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.189 8.939)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M171.746,181h-2.963a6.643,6.643,0,0,0-2.973.73,18.589,18.589,0,0,1,4.454,1.846,18.59,18.59,0,0,1,4.454-1.846A6.643,6.643,0,0,0,171.746,181Z",
    transform: "translate(-165.81 -181)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.323 13.384)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M453.482,271A1.482,1.482,0,0,0,452,272.482v2.963a1.482,1.482,0,1,0,2.963,0v-2.963A1.482,1.482,0,0,0,453.482,271Z",
    transform: "translate(-452 -271)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 13.384)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.482,271A1.482,1.482,0,0,0,0,272.482v2.963a1.482,1.482,0,1,0,2.963,0v-2.963A1.482,1.482,0,0,0,1.482,271Z",
    transform: "translate(0 -271)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.482 10.421)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M30.741,211a.74.74,0,0,0-.741.741v.741a2.966,2.966,0,0,1,2.963,2.963v2.963A2.966,2.966,0,0,1,30,221.371v.741a.74.74,0,0,0,.741.741,17.372,17.372,0,0,1,9.68,3.013V213.4A18.685,18.685,0,0,0,30.741,211Z",
    transform: "translate(-30 -211)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.384 10.421)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M281.421,212.482v-.741a.74.74,0,0,0-.741-.741,18.685,18.685,0,0,0-9.68,2.4v12.466a17.372,17.372,0,0,1,9.68-3.013.74.74,0,0,0,.741-.741v-.741a2.966,2.966,0,0,1-2.963-2.963v-2.963A2.966,2.966,0,0,1,281.421,212.482Z",
    transform: "translate(-271 -211)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearning);
export default __webpack_public_path__ + "static/media/learning.7fa82139608ca416c6da20ea3b13b8f1.svg";
export { ForwardRef as ReactComponent };